import { FC, useMemo, useState } from "react";
import { Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

import { maxMobileMediaWidth } from "config/constants";

import Button from "components/Buttons/Button";

import { ETransferType } from "store/transfers/types";
import { openModal } from "store/modals/actions";
import { EModals } from "store/modals/types";
import { getUserInfoDataSelector } from "store/user/selectors";

import { hasRiskPermission } from "utils/hasRiskPermission";

import VectorIcon from "../../../Icons/VectorIcon";
import PlusIcon from "../../../Icons/PlusIcon";

const CustomLabelsDetailAddLabelMenu: FC<{mobileEmptyPage?:boolean}> = ({ mobileEmptyPage }) => {
  const { t, i18n } = useTranslation();
  const [ open,setOpen ] = useState(false);
  const dispatch = useDispatch();
  const isMaxMobile = useMediaQuery({ query: `(max-width: ${maxMobileMediaWidth}px)` });
  const userInfo = useSelector(getUserInfoDataSelector);
  
  const items = useMemo(() => [
    {
      key: ETransferType.import_wallet,
      onClick: () => {
        setOpen(false);
        if (hasRiskPermission(userInfo)) {
          dispatch(openModal({ modal: EModals.customLabelsDetailAddLabel }));
        }
      },
      label: t("amlRiskCustomLabels.addManually")
    },
    {
      key: ETransferType.deposit,
      onClick: () => {
        setOpen(false);
        if (hasRiskPermission(userInfo)) {
          dispatch(openModal({ modal: EModals.customLabelsDetailCSV }));
        }
      },
      label: t("amlRiskCustomLabels.importFromCSV")
    },
  ].filter(item => Boolean(item.label)), [i18n.language]);
  const handleOpen = (flag: boolean) => {
    setOpen(flag);
  };

  return <Dropdown
    menu={{
      items,
    }}
    open={open}
    trigger={["click"]}
    placement="bottomRight"
    onOpenChange={handleOpen}
    overlayClassName="custom-labels-detail__add-label-menu"
  >
    {isMaxMobile && !mobileEmptyPage ? <PlusIcon className="custom-label-detail-header-right"/> : <Button
      title={t("amlRiskCustomLabels.addLabel")}
      className="transfers-header__new-transfer custom-detail"
      icon={<VectorIcon/>} iconLast={true}/>}
  </Dropdown>;
};

export default CustomLabelsDetailAddLabelMenu;
